import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@core/service/api/api.service';

@Injectable({ providedIn: 'root' })
export class NewsletterService {
    private readonly _apiService = inject(ApiService);

    subscribe(email: string): Observable<void> {
        return this._apiService.post<void, { email: string }>('/newsletter/subscribe', { email });
    }
}
